import React from 'react';
import cn from 'classnames';

import * as interfaces from 'interfaces';
import { useClientContext, useTranslationContext } from 'hooks';
import { getClientOptions } from 'scripts/clients/index'

import classes from './AnswerThumbnail.module.scss';
import Icons from 'shared/Icons';

const scrollToTop = function () {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  window.scrollTo(0, 0)
}

export default function AnswerItem(props: {
  answer: interfaces.AnswerInterface;
  handleClick: (a: interfaces.AnswerInterface) => void;
}) {
  const { answer, handleClick = (a: interfaces.AnswerInterface) => { } } = props;
  const { client } = useClientContext();
  const { t, language } = useTranslationContext();

  const getQuestionTranslation = (question: interfaces.QuestionInterface) => {
    if (language !== question.originalLanguage && question.translations && question.translations[language])
      return question.translations[language];
    return question.text;
  }

  const preferenceForNames = getClientOptions(client)?.videoThumbnails?.preferenceForNames || false;
  const text = preferenceForNames ? answer.question.user.firstName : getQuestionTranslation(answer.question);

  const onSelect = () => {
    if (window.innerWidth < 640) scrollToTop()
    handleClick(answer)
  }

  return (
    <div className={cn(classes.AnswerThumbnail, 'AnswerThumbnail')} onClick={onSelect}>
      <div
        className={cn(classes.thumbnail, 'thumbnail')}
        style={{
          backgroundImage: `url("${answer.imageUrl}")`,
          ...(answer.imageUrl ? { color: 'transparent' } : {}),
          borderColor: client?.videoLinksColour || 'transparent'
        }}
      >
        <Icons iconType="photo-video" />
      </div>

      <div className={cn(classes.thumbnailText, 'thumbnailText')} style={{ color: client?.videoLinksColour }}>
        {text}
      </div>

      <div className={cn(classes.attributes, 'attributes')}>
        <div className={classes.votes}>
          {answer.votes} {(answer.votes || 0) > 1 ? t("votes") : t("vote")} &nbsp;
        </div>

        <div className={classes.time}> • {new Date(answer.createdAt || 0).toLocaleString('default', { month: 'short', day: 'numeric' })}</div>
      </div>
    </div>
  );
}
